import { omitBy } from "lodash";

interface BasicObject {
  [x: string]: any;
}

export const parseOutEmptyObjects = (o: BasicObject) =>
  omitBy(o, (value) => Object.keys(value ?? {}).length === 0);
